<div *ngIf="kpi">
  <div class="card p-0 pt-4 mb-0">
    <div class="flex flex-column mx-4 mb-3">
      <div class="flex flex-column sm:flex-row justify-content-start sm:justify-content-between">
        <p class="inline-block text-4xl flex-order-1 sm:flex-order-0">
          {{'model.kpi' | transloco}} {{kpi.name}}
        </p>
        <div class="flex-order-0 sm:flex-order-1">
          <button
            *ngIf="'ROLE_OPERATOR' | userHasRole"
            [label]="'common.edit' | transloco"
            pButton
            pRipple
            class="mr-2 p-button-primary mt-1 mb-3 sm:mb-0 w-full sm:w-auto"
            icon="pi pi-pencil"
            routerLink="../edit"
          ></button>
        </div>
      </div>
      <div>
        <p *ngIf="kpi.description"><b>{{'attribute.description' | transloco}}: </b>{{kpi.description}}</p>
        <p *ngIf="!kpi.description"><i>{{'empty.description' | transloco}}</i></p>
      </div>
    </div>
    <div>
      <p-tabMenu
        #tab
        [model]="items"
        [activeItem]="activeItem"
        (click)="activateMenu(tab)"
        class="hidden xl:inline"
      ></p-tabMenu>
      <p-tabMenu
        #tabIcon
        [model]="items"
        [activeItem]="activeItem"
        (click)="activateMenu(tabIcon)"
        class="xl:hidden"
      >
        <ng-template pTemplate="item" let-item let-i="index">
          <i [className]="item.icon"></i>
        </ng-template>
      </p-tabMenu>
    </div>
  </div>
  <div class="with-margin">
    <app-kpi-overview [kpi]="kpi" *ngIf="activeItem.id == 'overview'"></app-kpi-overview>
    <app-kpi-components [kpi]="kpi" *ngIf="activeItem.id == 'components'"></app-kpi-components>
    <app-kpi-measures [kpi]="kpi" *ngIf="activeItem.id == 'measures'"></app-kpi-measures>
  </div>
</div>
